import React, { createContext, useState, useContext } from 'react';
import CustomDialog from './CustomDialog';
import AnnouncementDialog from './AnnouncementDialog';

type DialogType = 'alert' | 'confirm' | 'prompt' | 'announcement';

interface DialogOptions {
  type: DialogType;

  /* bestehende Dialoge */
  message?: string;
  onConfirm?: (value?: string) => void;
  onCancel?: () => void;
  confirmButton?: string;
  cancelButton?: string;
  title?: string;
  danger?: boolean;

  /* Announcement */
  props?: any;
}

const DialogContext = createContext<(options: DialogOptions) => void>(() => {});

export const useDialog = () => useContext(DialogContext);

export const DialogProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [options, setOptions] = useState<DialogOptions | null>(null);

  const showDialog = (opts: DialogOptions) => {
    setOptions(opts);
  };

  const close = () => setOptions(null);

  return (
    <DialogContext.Provider value={showDialog}>
      {children}
      {options && (
        options.type === "announcement" ? (
          <AnnouncementDialog {...options.props} onClose={close} />
        ) : (
          <CustomDialog
            type={options.type}
            message={options.message ?? ""}
            title={options.title ?? ""}
            danger={options.danger}
            onConfirm={(val) => {
              options.onConfirm?.(val);
              close();
            }}
            onCancel={() => {
              options.onCancel?.();
              close();
            }}
            onClose={close}
            confirmButton={options.confirmButton}
            cancelButton={options.cancelButton}
          />
        )
      )}
    </DialogContext.Provider>
  );
};
